import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import './styles/NewPostButton.scss';

interface NewPostButtonProps {
    hashtag?: string;
}

const NewPostButton: React.FC<NewPostButtonProps> = ({ hashtag }) => {
    const handleClick = () => {
        const url = hashtag 
            ? `/social/new-post?hashtag=${encodeURIComponent(hashtag)}`
            : '/social/new-post';
        window.location.href = url;
    };
    
    return (
        <button
            onClick={handleClick}
            className="NewPostButton"
            aria-label="Create new post"
        >
            <AddIcon sx={{ fontSize: 24 }} />
        </button>
    );
};

export default NewPostButton;